import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging';
import { firebaseConfig } from './config/firebaseConfig';

export { VAPID_KEY } from './config/firebaseConfig';

let app = null;
let analyticsInstance = null;
let analyticsPromise = null;
let messagingPromise = null;

if (firebaseConfig.appId) {
  app = initializeApp(firebaseConfig);
} else {
  console.warn(
    '[Firebase] Missing web appId. Add a Web app in Firebase Console (tenantscore-86873) ' +
      'and set appId in src/config/firebase.config.json'
  );
}

if (!firebaseConfig.measurementId && firebaseConfig.appId) {
  console.warn(
    '[Firebase Analytics] Missing measurementId. In Firebase Console → Project settings → ' +
      'Your apps → Web app, copy the measurementId (G-...) into firebase.config.json'
  );
}

export const getAnalyticsIfSupported = async () => {
  if (!app || !firebaseConfig.measurementId) {
    return null;
  }

  if (analyticsInstance) {
    return analyticsInstance;
  }

  if (!analyticsPromise) {
    analyticsPromise = isAnalyticsSupported()
      .then((supported) => {
        if (!supported) {
          console.warn('[Firebase Analytics] Not supported in this browser/environment.');
          return null;
        }

        analyticsInstance = getAnalytics(app);
        return analyticsInstance;
      })
      .catch(() => null);
  }

  return analyticsPromise;
};

export const resetMessagingInstance = () => {
  messagingPromise = null;
};

export const getMessagingIfSupported = async () => {
  if (!app) {
    return null;
  }

  if (!messagingPromise) {
    messagingPromise = isMessagingSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }

  return messagingPromise;
};
